import { useSnackbar } from "notistack";
import { useProducts } from "../../admin/products/useProducts";
import { areProductsAndCalculationCurrenciesEqual } from "../../calculations/areProductsAndCalculationCurrenciesEqual";
import type { CalculationVersion } from "../../calculations/calculationTypes";
import { ISO_DATE_FORMAT } from "../../dayjs";
import { findSaveDiscrepancies, type SaveDiscrepancies } from "../../sharedComponents/participantCountValidation";
import type { CalculationDraft } from "../CalculationDraft";

export function useHandleSaveVersion(
  doCreate: (draft: CalculationDraft) => Promise<void>,
  setDiscrepancyModal: (discrepancies: SaveDiscrepancies) => void,
  setPendingDraft: (draft: CalculationDraft) => void,
): { handleSaveVersion: (draft: CalculationDraft) => Promise<void> } {
  const { enqueueSnackbar } = useSnackbar();
  const { products } = useProducts();

  const handleSaveVersion = async (draft: CalculationDraft) => {
    if (!draft.packageId) {
      const compat = {
        currency: draft.currency,
        products: draft.products.map((p) => ({
          id: p.id,
          date: draft.basicData.startDate!.add(p.daysShift, "days").format(ISO_DATE_FORMAT),
          options: p.options,
        })),
      } as unknown as CalculationVersion;
      const currenciesOk = areProductsAndCalculationCurrenciesEqual(compat, products);
      if (!currenciesOk) {
        enqueueSnackbar("Nie można utworzyć pakietu. Wybierz produkty i sprawdź zgodność waluty.", {
          variant: "error",
        });
        return;
      }
    }

    const totalParticipants = draft.basicData.peopleCount + draft.basicData.freePeopleCount;
    const discrepancies = findSaveDiscrepancies(totalParticipants, draft.products, products);
    if (discrepancies) {
      setDiscrepancyModal(discrepancies);
      setPendingDraft(draft);
      return;
    }

    await doCreate(draft);
  };
  return { handleSaveVersion };
}
